import { defineComponent as _defineComponent } from 'vue'
import { getCurrentInstance, onMounted, ref } from "vue";
import { useOperationStore } from "@/stores/operation";
import { setCustomCssVariables, getFileData } from "@/libs/tools";
import { i18n } from "@/main";
import { useRoute } from "vue-router/composables";

export default /*#__PURE__*/_defineComponent({
  __name: 'App',
  setup(__props) {

const route = useRoute();

const operationStore = useOperationStore();
const currentVueInstance = getCurrentInstance();
const waitForComponent = ref("");

const setBackgroundImage = (banner: string, blur: number) => {
  document.body.style.backgroundImage = `url('${banner}')`;
  document.body.style.backgroundSize = "cover";
  document.body.style.backgroundRepeat = "no-repeat";
  document.body.style.backgroundPosition = "center";
  document.body.style.backdropFilter = `blur(${blur}px)`;
};

onMounted(async () => {
  try {
    await operationStore?.getOperation();
    if (operationStore?.operationData) {
      /* GESTION DE LA LANG */
      const lang = operationStore?.operationData?.langs[0] || "fr";
      let savedLang = "";

      if (operationStore?.operationData?.langs.length > 1) {
        savedLang =
          localStorage.getItem("lang") ??
          operationStore?.operationData?.langs[0];
      } else {
        savedLang = operationStore?.operationData?.langs[0];
      }

      if (
        currentVueInstance &&
        currentVueInstance.proxy &&
        operationStore &&
        lang !== undefined
      ) {
        currentVueInstance.proxy.$i18n.locale = savedLang ?? lang;

        /* GESTION DU FAVICON */
        const files = operationStore?.filesData ?? [];
        const favicon = getFileData(files, "favicon");
        const linkfav: HTMLLinkElement | null =
          document.querySelector("link[rel='icon']");
        if (linkfav) {
          linkfav.href = favicon?.uri || "/favicon.ico";
        }

        const customStore = operationStore?.customData ?? {};
        if (customStore) {
          /* SET CSS VARS IN ROOT */
          setCustomCssVariables(customStore);
        }
      }
    }

    setTimeout(() => {
      waitForComponent.value = i18n.t("error.no_operartion") as string;
    }, 1000);
  } catch (error) {
    console.error(error);
  }
});

return { __sfc: true,route, operationStore, currentVueInstance, waitForComponent, setBackgroundImage }
}

})